import { withTransition } from "../decorators/index.js";
import { AbstractSliderChild } from "./AbstractSliderChild.js";
class SliderDots extends withTransition(AbstractSliderChild) {
  /**
   * Config.
   */
  static config = {
    name: "SliderDots",
    refs: ["dots[]"]
  };
  /**
   * Get target.
   */
  get target() {
    return this.$refs.dots;
  }
  /**
   * The current active index.
   */
  currentIndex = -1;
  /**
   * Update dots classes according to the new index.
   */
  update(index) {
    if (index !== this.currentIndex) {
      this.leave(this.$refs.dots[this.currentIndex]);
      this.enter(this.$refs.dots[index]);
      this.currentIndex = index;
    }
  }
  /**
   * Go to the given index on dot click.
   */
  onDotsClick({ index }) {
    this.$parent.goTo(index);
  }
}
export {
  SliderDots
};
//# sourceMappingURL=SliderDots.js.map
